
import m from 'mithril'

import popup from '../popup'
import { tick_icon, lock_icon } from '../../components/icons'


const column_adjuster = {
    view: vnode => {
        return [

            m(popup,
                {
                    class: 'dynamic_popup',
                    on_click_outside: () => {
                        vnode.attrs.apply()
                    }

                },

                m('.options_header', 'Change Columns'),

                m('.options_grid',
                    vnode.attrs.all_columns.map(column =>

                        m('button.filter_option.filter_option_wide',
                            {
                                class:
                                    vnode.attrs.enabled_columns.some(e => e == column.code) ? 'active' : '',

                                onclick: () => {
                                    if (column.code == 'pen_name') {
                                        return
                                    }

                                    let enabled = vnode.attrs.enabled_columns
                                    if (enabled.some(e => e == column.code)) {
                                        vnode.attrs.change_columns(enabled.filter(e => e != column.code))
                                    }
                                    else {
                                        enabled.push(column.code)
                                        vnode.attrs.change_columns(enabled)
                                    }
                                }
                            },
                            column.code == 'pen_name' ? m(lock_icon) :
                                (vnode.attrs.enabled_columns.some(e => e == column.code) ? m(tick_icon) : []),
                            m(column.header)
                        ))

                ),

                m('.filter_option_save_buttons',

                    m('button.filter_button.dark_link',
                        {
                            onclick: () => {
                                vnode.attrs.reset()
                            }
                        },
                        m('.text', 'Default')
                    ),

                    m('button.filter_button.my_link',
                        {
                            onclick: () => { vnode.attrs.apply() }
                        },
                        m('.text', 'Close')
                    )
                )
            )
        ]
    }
}

export default column_adjuster